const { Component, render, findDOMNode, Fragment } = wp.element;
const { __ } = wp.i18n;

import axios from 'axios';
import { Provider, connect } from 'react-redux';
import { Comparison_Tables_Carousel as Carousel } from "./carousel"
import { Comparison_Tables_Ratings as Ratings } from "./ratings"
let psl = require('psl');

import {
  Comparison_Tables_Product_Url as get_product_url,
  Comparison_Tables_domain_from_url as domain_from_url,
  Comparison_Tables_isset as isset,
  Comparison_Tables_toRGBA as toRGBA
} from "./utils.js";


const alias = 'Comparison_Tables-frontend-'
class Comparison_Tables_View extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      products: {},
      date: false
    }

    if( isset(this, 'props', 'products') ){
      this.state.products = this.props.products;
      this.state.rows = this.props.rows;
    }
  }

  getItemDetails( ID )
  {
    this.state.show_loader = true;

    axios.post( Comparison_Tables.ajax_url, {
      sub_action: 'get_item',
      ID: ID
    })
    .then(res => {
      const { data } = res.data;

      this.setState({
        rows: data.rows,
        products: data.products,
        date: data.date,
      })
    })
  }

  render()
  {
    let { rows, products, show_loader, date } = this.state;

    const { selectedID, forceRebuild } = this.props;

    if( isset(this.props, 'products', 0 ) ) {
      products = this.props.products;
    }
    if( isset(this.props, 'rows', 0 ) ) {
      rows = this.props.rows;
    }

    if( selectedID > 0 && Object.keys(products).length == 0 ){
      this.getItemDetails( selectedID );
    }

    if( isset(this, 'props', 'forceRebuild' ) ){
      this.getItemDetails( selectedID );
    }

    if( Object.keys(products).length == 0 ){
      return '';
    }

    return <div className={ `${alias}wrapper` }>
      <table>
        <tbody>
          {
            rows.map( (row, rowIndex) => {
              if( row.publish == false ) return;

              return <tr className={ `ct-type-${row.type}` }>
                <td className={ `${alias}labels` }>{ row.show_label ? row.label : '' }</td>
                {
                  Object.keys( products ).map( key => {
                    const product = products[key];
                    const images = [];

                    let country = 'com';
                    if( isset(product, 'country') ){
                      country = product.country;
                    }

                    const product_url = get_product_url( product.asin, country, ( row.type == 'add-cart' ? 'cart' : 'detail' ) );

                    let hide_product = true;
                    if( !isset(product, 'hide_status') ){
                      hide_product = false;
                    }

                    if( hide_product == false ) {
                      return;
                    }

                    Object.keys(product['data']['images']).map( key => {
                      const img = product['data']['images'][key].url;
                      let url = img.replace(".jpg", `._SS200_.jpg`);
                      images.push( url );
                    })

                    if( !isset(product, 'customFields') ) {
                      product['customFields'] = {};
                    }

                    let customValue = '';
                    if( row.type == 'custom-field' ) {

                      if( isset(product, 'customFields', rowIndex) && product['customFields'][rowIndex] !== null ){
                        const keys = product['customFields'][rowIndex].split("|");

                        customValue = product[keys[0]];

                        // some lazy code here, I want to avoid eval function. We created code for only 5 keys deep
                        if( keys.length == 1 ) customValue = product[keys[0]];
                        if( keys.length == 2 ) customValue = product[keys[0]][keys[1]];
                        if( keys.length == 3 ) customValue = product[keys[0]][keys[1]][keys[2]];
                        if( keys.length == 4 ) customValue = product[keys[0]][keys[1]][keys[2]][keys[3]];
                        if( keys.length == 5 ) customValue = product[keys[0]][keys[1]][keys[2]][keys[3]][keys[4]];

                        // avoid user put an array instand of string
                        if( typeof(customValue) == 'object' ){
                          const _arr = [].concat(...Object.values(customValue))
                          customValue = _arr.join("\n");
                        }
                      }
                    }

                    if( row.type == 'text' ) {
                      if( isset(product, 'customText', rowIndex) ){
                        customValue = product['customText'][rowIndex];
                      }
                    }

                    if( row.type == 'freeshipping' ) {
                      customValue = __('Free Shipping', 'aat-apct');
                      if( isset(product, 'freeshipping', rowIndex) ){
                        customValue = product['freeshipping'][rowIndex];
                      }
                    }

                    if( row.type == 'read-more' ) {
                      customValue = __('Read More', 'aat-apct');
                      if( isset(product, 'readMore', rowIndex) ){
                        customValue = product['readMore'][rowIndex];
                      }
                    }

                    if( row.type == 'buy' ) {
                      customValue = __('Buy Now', 'aat-apct');
                      if( isset(product, 'buyBtn', rowIndex) ){
                        customValue = product['buyBtn'][rowIndex];
                      }
                    }

                    if( row.type == 'add-cart' ) {
                      customValue = __('Add to Cart', 'aat-apct');
                      if( isset(product, 'addCart', rowIndex) ){
                        customValue = product['addCart'][rowIndex];
                      }
                    }

                    let style = {};
                    if( isset(product, 'labelColor') ){
                      const rgbaColor = toRGBA( product['labelColor'] );

                      style['backgroundColor'] = `rgba( ${rgbaColor['r']}, ${rgbaColor['g']}, ${rgbaColor['b']}, 0.05 )`;
                      style['borderLeft'] = `1px solid rgba( ${rgbaColor['r']}, ${rgbaColor['g']}, ${rgbaColor['b']}, 0.2 )`;
                      style['borderRight'] = `1px solid rgba( ${rgbaColor['r']}, ${rgbaColor['g']}, ${rgbaColor['b']}, 0.2 )`;
                      style['borderBottom'] = `1px solid rgba( ${rgbaColor['r']}, ${rgbaColor['g']}, ${rgbaColor['b']}, 0.2)`;

                      if(rowIndex == 0 && isset(product, 'customLabel') ){
                        style['borderTop'] = `1px solid ${product['labelColor']}`;
                      }
                    }

                    return <td style={ style }>
                      {
                        rowIndex == 0 ? <span className={ `${alias}border-right` } style={{
                        borderRight: `1px solid ${product['labelColor']}`
                      }}></span> : ''
                      }

                      {
                        rowIndex == 0 && isset(product, 'customLabel') && isset(product, 'labelColor') ? <div className={ `${alias}header` } style={{
                          backgroundColor: product['labelColor']
                        }}>{ product['customLabel'] }</div> : ''
                      }

                      { row.type == 'thumb' ? <a href={ product_url } target="_blank" className={ `${alias}thumb` }><img src={ images[0] } /></a> : '' }
                      { row.type == 'gallery' ? <Carousel url={ product_url } items={ images } /> : '' }
                      { row.type == 'ratings' ? <Ratings url={ product_url } rating={ product.data.ratings } /> : '' }

                      { row.type == 'title' ? <a href={ product_url } className={ `${alias}title` } target="_blank">{ product.data.title }</a> : '' }

                      { row.type == 'prime' ? <span className={ `${alias}prime-status` }>{
                        isset(product, 'prime') ? <img src={ `${Comparison_Tables.assets_url}/prime.png` } /> : <span className="ct-cross"> </span>
                      }</span> : '' }

                      { row.type == 'list-price' ? <span className={ `${alias}list-price` }>{ __('From', 'aat-apct') } { product.data.list_price }</span> : '' }
                      { row.type == 'sale-price' ? <span className={ `${alias}sale-price` }>{ product.data.amazon_price }</span> : '' }
                      { row.type == 'full-price' ? <div className={ `${alias}full-price` }>
                        { product.data.list_price ? <del>{ product.data.list_price }</del> : '' }
                        { product.data.amazon_price ? <strong>{ product.data.list_price }</strong> : '' }
                      </div> : '' }

                      { row.type == 'yesno' ? isset(product['yesno'], rowIndex) && product['yesno'][rowIndex] ? <span className={ `${alias}mark ct-checkmark` }></span> : <span className={ `${alias}mark ct-cross` }></span> : '' }
                      { row.type == 'custom-field' ? isset(product['customFields'], rowIndex) ? <div className={ `row-type-${row.label}` } dangerouslySetInnerHTML={{ __html: customValue }}></div> : '' : '' }
                      { row.type == 'text' ? isset(product['customText'], rowIndex) ? customValue : '' : '' }
                      { row.type == 'read-more' ? customValue != "" ? <a className={ `${alias}read-more` } href={ product_url } target="_blank">{ customValue }</a> : '' : '' }
                      { row.type == 'freeshipping' ? customValue != "" ? product.data.freeshipping ? <span className={ `${alias}free-shipping` }>{ customValue }</span> : <span className="ct-cross"> </span> : '' : '' }

                      { row.type == 'buy' ? customValue != "" ? <a className={ `${alias}buy-btn` } href={ product_url } target="_blank"><span className="ct-amazon"></span>{ customValue }</a> : '' : '' }
                      { row.type == 'add-cart' ? customValue != "" ? <a className={ `${alias}add-to-cart-btn` } href={ product_url } target="_blank"><span className="ct-cart-add"></span>{ customValue }</a> : '' : '' }
                    </td>
                  })
                }
              </tr>

            })
          }
        </tbody>
      </table>

      <p className={ `${alias}info` }>{ sprintf( __('Last update on %s Source: Amazon Affiliates', 'aat-apct'), date) }</p>
    </div>
  }
}

const mapStateToProps = state => {
  return state.app;
};

export default Comparison_Tables_View;



// WEBPACK FOOTER //
// ./src/view.js